// extracted by mini-css-extract-plugin
export default {"description":"style_description__SLLkQ","inputContainer":"style_inputContainer__PpnBb","buttonsContainer":"style_buttonsContainer__Rwfbz"};